import {
    GET_CATERING_DASHBOARD_SUMMARY,
} from '../../../modules/constants';

export const getCateringDashboardSummary = (payload) => ({
    type: GET_CATERING_DASHBOARD_SUMMARY,
    payload,
});
